import { render } from "./EditP2LogisticsModal.vue?vue&type=template&id=593d7276&scoped=true"
import script from "./EditP2LogisticsModal.vue?vue&type=script&lang=js"
export * from "./EditP2LogisticsModal.vue?vue&type=script&lang=js"

import "./EditP2LogisticsModal.vue?vue&type=style&index=0&id=593d7276&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-593d7276"]])

export default __exports__